export default "__VITE_ASSET__BdlU$5ld__"